import React from "react";
import PropTypes from "prop-types";
import lo1 from "../../assets/images/logo-company/cty4.png";
import { useRef, useState, useEffect } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import LoginHeader from "../../components/header/LoginHeader";
import LoginMobileHeader from "../../components/header/LoginMobileHeader";
import InstituteMobileHeader from "../../components/header/InstituteMobileHeader";
import CRMobileHeader from "../../components/header/CRMobileHeader";
import InstituteHeader from "../../components/header/InstituteHeader";
import CRHeader from "../../components/header/CRHeader";
import NonLoginHeader from "../../components/header/NonLoginHeader";
import JobDetails from "./JobDetails";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";

JobDetailsMain.propTypes = {};


function JobDetailsMain(props) {
    const progressRef = useRef();
    const [targetHeight, setTargetHeight] = useState(0);
    const [toggle, setToggle] = useState({
        key: "",
        status: false,
    });
    const [isShowMobile, setShowMobile] = useState(false);

    const handleToggle = (key) => {
        if (toggle.key === key) {
            setToggle({
                status: false,
            });
        } else {
            setToggle({
                status: true,
                key,
            });
        }
    };

    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        if (progressRef?.current) {
            const offsetHeight = progressRef?.current?.offsetTop;
            setTargetHeight(offsetHeight);
        }
    }, [progressRef]);

    const module = localStorage.getItem('Module');

    // ...............................Job Details.......................................
    return (
        <>
            {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
                        module === 'recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
                            <MobileHeader handleMobile={handleMobile} />}
            {module === 'Candidate' ? <LoginHeader clname="searchjobheader" handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteHeader clname="searchjobheader" handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRHeader clname="searchjobheader" handleMobile={handleMobile} /> :
                        module === 'recruiter' ? <CRHeader clname="searchjobheader" handleMobile={handleMobile} /> :
                            <NonLoginHeader handleMobile={handleMobile} />}

            <div className="pt-70">
                <JobDetails />
                <Footer />
                <Gotop />
            </div>
        </>
    );
}

export default JobDetailsMain;

